export default () => ({
    activeHead: '3',
    interval: null,
    paused: false,

    head: {
        ['@click']() {
            this.stopAutoAdvance()
            this.activeHead = this.$el.dataset.head
        },

        [':class']: 'activeHead === $el.dataset.head ? "--is-active" : ""',
    },

    headContent: {
        [':class']: 'activeHead === $el.dataset.head ? "--is-active" : ""',
        // ['x-show']: 'activeHead === $el.dataset.head',
    },

    init() {
        this.startAutoAdvance()
    },

    startAutoAdvance() {
        this.interval = setInterval(() => {
            if (this.paused) return

            const heads = Array.from(document.querySelectorAll('[data-head]')).map(el => el.dataset.head)
            const currentHead = heads.indexOf(this.activeHead)
            const prevHead = (currentHead - 1 + heads.length) % heads.length
            this.activeHead = heads[prevHead]
        }, 5000)
    },

    stopAutoAdvance() {
        this.paused = true
        clearInterval(this.interval)
    },

    // Function available but not used
    open() {
        this.activeHead = this.$el.dataset.head
    },
})
